import { render } from "./WrongToken.vue?vue&type=template&id=c31f74b2"
import script from "./WrongToken.vue?vue&type=script&lang=js"
export * from "./WrongToken.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__